import React from 'react';
import { useNavigate } from 'react-router-dom';
import { ArrowLeft } from 'lucide-react';
import { Button } from './button';

/**
 * Universeller Zurück-Button für alle Seiten
 * 
 * Props:
 * - to: Optionaler Ziel-Pfad (default: browser history back)
 * - onClick: Optionaler Click-Handler (überschreibt to und navigate)
 * - label: Optionaler Text (default: "Zurück")
 * - className: Zusätzliche CSS-Klassen
 */
export function BackButton({ to, onClick, label = "Zurück", className = "" }) {
  const navigate = useNavigate();
  
  const handleClick = () => {
    if (onClick) {
      onClick();
    } else if (to) {
      navigate(to);
    } else {
      navigate(-1);
    }
  };
  
  return (
    <Button
      variant="ghost"
      size="sm"
      onClick={handleClick}
      className={`gap-2 text-gray-400 hover:text-white hover:bg-gray-800/50 ${className}`}
      data-testid="back-button"
    >
      <ArrowLeft className="w-4 h-4" />
      {label}
    </Button>
  );
}

export default BackButton;
